import { render } from "./HotkeyItem.vue?vue&type=template&id=8b47afd2"
import script from "./HotkeyItem.vue?vue&type=script&lang=js"
export * from "./HotkeyItem.vue?vue&type=script&lang=js"

import "./HotkeyItem.vue?vue&type=style&index=0&id=8b47afd2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__